import React from "react";
import { Box, List, ListItem, ListItemAvatar, ListItemText, makeStyles, Typography, useMediaQuery, useTheme } from "@material-ui/core";
import { useSelector } from "react-redux";
import { categoryIcons, getCategoryCount, getCustomItemsCount } from "../inventory/InventoryHelper";

const useStyles = makeStyles((theme) => ({
    listContainer: {
        [theme.breakpoints.down("sm")]: {
            display: "flex",
            overflowX: "auto",
            whiteSpace: "nowrap",
            padding: 0,
        }
    },
    categoryMobileContain: {
        [theme.breakpoints.down("sm")]: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between",
            cursor: "pointer",
            width: "6.5rem",
            padding: "1rem 1rem 0 1rem",
        }
    },
    categoryBox: {
        [theme.breakpoints.down("sm")]: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
        }
    },
    iconBox: {
        [theme.breakpoints.down("sm")]: {
            position: "relative",
            width: 56,
            height: 56,
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 6,
        }
    },
    countBox: {
        [theme.breakpoints.down("sm")]: {
            position: "absolute",
            top: "-6px",
            right: "-16px",
            minWidth: 30,
            minHeight: 24,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontWeight: 600,
            borderRadius: "1rem",
        }
    },
    categoryContain: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderRadius: "8px",
        marginBottom: "8px",
        cursor: "pointer",
    },
    categoryCount: {
        width: 30,
        height: 30,
        borderRadius: "50%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "16px",
        fontWeight: "bold",
        backgroundColor: "#FFFFFF",
    },
}));

const Category = ({ setInventoryMode, selectedCategory, setSelectedCategory }) => {
    const classes = useStyles();
    const theme = useTheme();
    const isMobileView = useMediaQuery(theme.breakpoints.down("sm"));

    const inventoryData = useSelector((state) => state.inventoryInfo);
    const inventoryList = inventoryData.get("inventory");

    return (
        <>
            {isMobileView ? (
                // 👉 Mobile View
                <List className={classes.listContainer}>
                    {inventoryList.map((category, index) => {
                        const categoryId = category.get("id");
                        const isSelected = selectedCategory === categoryId;
                        const categoryCount = getCategoryCount(category);
                        return (
                            <ListItem
                                key={categoryId}
                                className={`${classes.categoryMobileContain} ${index === 0 && "pl-0"}`}
                                onClick={() => { setSelectedCategory(categoryId); setInventoryMode("table"); }}
                            >
                                <Box className={classes.categoryBox}>
                                    <ListItemAvatar
                                        className={classes.iconBox}
                                        style={{
                                            backgroundColor: isSelected ? "#EE553B" : "#FFFFFF",
                                            border: isSelected ? "2px solid #EE553B" : "2px solid #000000DE",
                                        }}
                                    >
                                        {categoryIcons[category.get("name")](isSelected ? "active" : "in-active")}
                                        <Box
                                            className={classes.countBox}
                                            style={{
                                                color: categoryCount > 0 ? "#EE553B" : "#FFFFFF",
                                                background: categoryCount > 0 ? "#FFFFFF" : "#000000DE",
                                                border: categoryCount > 0 ? "1px solid #EE553B" : "none",
                                            }}
                                        >
                                            {categoryCount}
                                        </Box>
                                    </ListItemAvatar>
                                    <Typography
                                        variant="subtitle2"
                                        color={isSelected ? "primary" : "textPrimary"}
                                        style={{
                                            fontWeight: isSelected ? 600 : 500,
                                            whiteSpace: "normal",
                                            textAlign: "center"
                                        }}
                                    >
                                        {category.get("displayName")}
                                    </Typography>
                                </Box>
                            </ListItem>
                        );
                    })}
                    <ListItem
                        className={classes.categoryMobileContain}
                        onClick={() => { setSelectedCategory("custom_items"); setInventoryMode("table"); }}
                    >
                        <Box className={classes.categoryBox}>
                            <ListItemAvatar
                                className={classes.iconBox}
                                style={{
                                    backgroundColor: selectedCategory === "custom_items" ? "#EE553B" : "#FFFFFF",
                                    border: selectedCategory === "custom_items" ? "2px solid #EE553B" : "2px solid #000000DE",
                                }}
                            >
                                {categoryIcons["custom"](selectedCategory === "custom_items" ? "active" : "in-active")}
                                <Box
                                    className={classes.countBox}
                                    style={{
                                        color: getCustomItemsCount(inventoryData) > 0 ? "#EE553B" : "#FFFFFF",
                                        background: getCustomItemsCount(inventoryData) > 0 ? "#FFFFFF" : "#000000DE",
                                        border: getCustomItemsCount(inventoryData) > 0 ? "1px solid #EE553B" : "none",
                                    }}
                                >
                                    {getCustomItemsCount(inventoryData)}
                                </Box>
                            </ListItemAvatar>
                            <Typography
                                variant="subtitle2"
                                color={selectedCategory === "custom_items" ? "primary" : "textPrimary"}
                                style={{
                                    fontWeight: selectedCategory === "custom_items" ? 600 : 500,
                                    whiteSpace: "normal",
                                    textAlign: "center"
                                }}
                            >
                                Custom Items
                            </Typography>
                        </Box>
                    </ListItem>
                </List >
            ) : (
                // 👉 Web View
                <List>
                    {inventoryList.map((category) => {
                        const categoryId = category.get("id");
                        const isSelected = selectedCategory === categoryId;
                        const categoryCount = getCategoryCount(category);
                        return (
                            <ListItem
                                key={categoryId}
                                className={classes.categoryContain}
                                onClick={() => { setSelectedCategory(categoryId); setInventoryMode("table"); }}
                                style={{
                                    backgroundColor: isSelected ? "#EE553B" : "#FFFFFF",
                                    color: isSelected ? "#FFFFFF" : "#000000DE",
                                }}
                            >
                                <ListItemAvatar style={{ minWidth: 40 }}>
                                    {categoryIcons[category.get("name")](isSelected ? "active" : "in-active")}
                                </ListItemAvatar>
                                <ListItemText
                                    primary={
                                        <Typography style={{ fontWeight: 600 }}>
                                            {category.get("displayName")}
                                        </Typography>
                                    }
                                />
                                <Box
                                    className={classes.categoryCount}
                                    style={{
                                        color: categoryCount > 0 ? "#EE553B" : "#000000DE",
                                        border: categoryCount > 0 ? "1px solid #EE553B" : "1px solid #000000DE",
                                    }}
                                >
                                    {categoryCount}
                                </Box>
                            </ListItem>
                        );
                    })}
                    <ListItem
                        className={classes.categoryContain}
                        onClick={() => { setSelectedCategory("custom_items"); setInventoryMode("table"); }}
                        style={{
                            backgroundColor: selectedCategory === "custom_items" ? "#EE553B" : "#FFFFFF",
                            color: selectedCategory === "custom_items" ? "#FFFFFF" : "#000000DE",
                        }}
                    >
                        <ListItemAvatar style={{ minWidth: 40 }}>
                            {categoryIcons["custom"](selectedCategory === "custom_items" ? "active" : "in-active")}
                        </ListItemAvatar>
                        <ListItemText
                            primary={
                                <Typography style={{ fontWeight: 600 }}>
                                    Custom Items
                                </Typography>
                            }
                        />
                        <Box
                            className={classes.categoryCount}
                            style={{
                                color: getCustomItemsCount(inventoryData) > 0 ? "#EE553B" : "#000000DE",
                                border: getCustomItemsCount(inventoryData) > 0 ? "1px solid #EE553B" : "1px solid #000000DE",
                            }}
                        >
                            {getCustomItemsCount(inventoryData)}
                        </Box>
                    </ListItem>
                </List>
            )}
        </>
    );
};

export default Category;